import React, { useState, useContext, useEffect } from 'react'
import styles from './address-details.module.scss'
import Button from 'src/components//button/Button'
import { StateContext } from '../../AppContext'
import { IState, IAddress } from 'src/Interface'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import AutocompletePoi from 'src/components/autocomplete/AutocompletePoi'
import { toast } from 'react-toastify'
import TextArea from 'src/components/textArea/TextArea'
import { DispatchContext } from 'src/AppContext'

interface IProps {
  close?: any
  branchId: number
  addressId: number
  companyId: number
}


const UserDetails: React.FunctionComponent<IProps> = ({ close, addressId, branchId }: IProps) => {
  const state: IState = useContext(StateContext)
  const [address, setAddress] = useState<IAddress>(null)
  const [comment, setComment] = useState('')
  const dispatch = useContext(DispatchContext)
  const currentAddress = state.addresses.find(address => address.id === Number(addressId))

  useEffect(() => {
    if (currentAddress) {
      setComment(currentAddress.comment)
    }
  }, [currentAddress])

  const updateAddress = () => {
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/branches/${branchId}/predefined_addresses/${addressId}`,
        {
          address: address ? address : currentAddress,
          comment
        }, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/predefined_addresses`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          dispatch({ type: 'SET_ADDRESSES', addresses: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
  }

  const deleteAddress = () => {
    if (state.user.accessToken) {
      axios.delete(`${baseApiURL()}/branches/${branchId}/predefined_addresses/${addressId}`,
        {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/predefined_addresses`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          dispatch({ type: 'SET_ADDRESSES', addresses: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
  }

  return (
    <>
      <header className={styles.header}>
        <h3>{`Favoritadresser`}</h3>
        <span className={styles.closeIcon} onClick={close}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </span>
      </header>
      <div className={styles.container}>
        <div className={styles.userInfo}>
          <h4 className={styles.subTitle}>Detaljer</h4>
          <AutocompletePoi modifiers='tw-mb-3' name='address' setAddress={() => setAddress} completedAddress={currentAddress} />
          <TextArea name='comment' value={comment} handleInputChange={() => setComment} placeholder='-' label='Kommentar' />

        </div>
      </div>
      <footer className={styles.footer}>
        <Button modifiers='tw-ml-auto' type='destructive' label='Fjern' handleClick={deleteAddress} />
        <Button modifiers='tw-ml-3' type='primary' label='Gem ændringer' handleClick={updateAddress} />
      </footer>
    </>
  )
}

export default UserDetails
